import React from "react";
import useCursosLogic from "./hooks/useCursosLogic";
import CursosView from "./pages/CursosView.jsx";

export default function Cursos() {
  const logic = useCursosLogic();
  return <CursosView {...logic} />;
}
